import React from "react";
import { Link } from "react-router-dom";
import { SocialIcon } from "react-social-icons";
import logo from "/assets/images/logo-lolivier_nav.webp";

export function Footer() {
  return (
    <footer className="bg-white rounded-lg shadow-sm dark:bg-gray-900 m-4">
      <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        <div className="lg:flex sm:items-center sm:justify-between">
          <a
            href="https://ecoleprimairepriveelolivier.fr/"
            className="flex items-center mb-7 lg:mb-0 space-x-3 rtl:space-x-reverse"
          >
            <img src={logo} className="h-10" alt="Flowbite Logo" />
            <span className="self-center text-2xl font-semibold whitespace-nowrap">
              École L'Olivier
            </span>
          </a>
          <ul className="flex flex-wrap items-center my-6 text-sm font-medium text-black sm:my-0">
            <Link to={"/notre-histoire"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Histoire
              </li>
            </Link>
            <Link to={"/projet-pedagogique"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Projet Pédagogique
              </li>
            </Link>
            {/* <Link to={"/activites-pedagogique"}>
          <li
            href="#"
            className="font-medium transition-colors focus:text-blue-500"
          >
            Activités pédagogique
          </li>
        </Link> */}
            <Link to={"/evenements"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Évènements
              </li>
            </Link>
            <Link to={"/modalites-inscription"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Inscription
              </li>
            </Link>
            <Link to={"/nous-soutenir"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Nous-soutenir
              </li>
            </Link>
            <Link to={"/contact"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Contactez-nous
              </li>
            </Link>
            <Link to={"/politique-rgpd"}>
              <li
                href="#"
                className="transition-colors focus:text-blue-500 hover:underline me-4 md:me-6"
              >
                Politique RGPD
              </li>
            </Link>
          </ul>
        </div>

        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm text-gray-600 sm:text-center ">
          © 2025{" "}
          <a
            href="https://ecoleprimairepriveelolivier.fr/"
            className="hover:underline"
          >
            École l'olivier
          </a>
          . Tous droits réservés.
        </span>
        <div className="social-icons flex mt-3 sm:justify-center items-center gap-5">
          <SocialIcon
            url="https://www.facebook.com/people/%C3%89cole-Lolivier/pfbid0FmwwDBkT3GmmGJwSG675SVWn6uajqF4FeHPDEpVry1ZEmcjmy9wPPGFCom4ymhMrl/?ref=ig_profile_ac"
            style={{ height: 40, width: 40 }}
            label="Page Facebook de l'école L'Olivier"
          />
          <SocialIcon
            url="https://www.youtube.com/@ecolepriveelolivier"
            style={{ height: 40, width: 40 }}
            label="Chaîne YouTube de l'école L'Olivier"
          />
          <SocialIcon
            url="https://www.instagram.com/ecolepriveelolivier/?igsh=OXF6bmozam9vaHBz"
            style={{ height: 40, width: 40 }}
            label="Page Instagram de l'école L'Olivier"
          />
        </div>
      </div>
    </footer>
  );
}
